var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
  trigger: 'hover',
  offset: 5,
  placement: 'top',
  content: _vm.description }),expression:"{\n  trigger: 'hover',\n  offset: 5,\n  placement: 'top',\n  content: description }"}]},[_c('svgicon',{attrs:{"name":_vm.imgName,"height":"20","width":"20","original":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }